module.exports = __webpack_public_path__ + "media/track_2.0e560d02.mp3";